/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/language_medium'
export default icon
